<div class="card">
  <div class="card-body">
    <h5>{{ 'registration_pricingInfo' | l10n }}</h5>
    <div class="infoCard-action" *ngIf="changeLink">
      &raquo; <a [routerLink]="[changeLink]">{{ 'registration_change' | l10n }}</a>
    </div>
    <div class="info-list">
      <div>
        <div><span class="badge badge-secondary price-total">{{ registration.price | price }}</span></div>
      </div>
      <div *ngIf="premiums.length + discounts.length > 0">
        <div class="label">{{ 'registration_discountsAndPremiums' | l10n }}</div>
        <div>
          <ul class="priceModifier-list">
            <li *ngFor="let regPremium of premiums">
              {{ regPremium.priceModifier.name }}
            </li>
            <li *ngFor="let regDiscount of discounts">
              {{ priceModifierName(regDiscount) }}
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="label">{{ 'registration_paymentTypeConfig' | l10n }}</div>
        {{ 'paymentType_' + registration.paymentTypeConfig.paymentTypeCode | l10n }}
        {{ registration.paymentTypeConfig.name }}
        <div class="paymentType-description">
          {{ 'paymentType_' + registration.paymentTypeConfig.paymentTypeCode + '_info' | l10n }}
        </div>
        <!-- <p class="description ml1Line">{{ 'paymentType_' + registration.paymentTypeConfig.paymentTypeCode + '_info' | l10n }}</p> -->
      </div>
    </div>
  </div>
</div>
